import builder from '../builder';
import ArrowButtonRight2Alternate from '../../streamline-icons/bold/arrow-button-right-2-alternate.svg';

export default builder(
  'IconArrowButtonRight2AlternateBold',
  ArrowButtonRight2Alternate,
);
